"use client";

import { useEffect } from "react";

/**
 * Run a callback when the user returns via browser Back/Forward or bfcache restore.
 * openNotebook() uses full navigation (location.assign), which can restore a frozen
 * dashboard page without remounting React Query. App-wide invalidation lives in
 * DashboardHistoryRestore (providers).
 */
export function useRefetchOnHistoryRestore(refetch: () => void) {
  useEffect(() => {
    const run = () => refetch();

    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) run();
    };

    const onPopState = () => run();

    window.addEventListener("pageshow", onPageShow);
    window.addEventListener("popstate", onPopState);
    return () => {
      window.removeEventListener("pageshow", onPageShow);
      window.removeEventListener("popstate", onPopState);
    };
  }, [refetch]);
}
